import React, { FunctionComponent, memo } from "react";

import { IProps } from "./select-value-container-summary.types";
import "./select-value-container-summary.scss";

/**
 * Display a summary of the number of items selected.
 * @param props.description Text description of items being displayed.
 * @param props.valuesCount How many values have been selected.
 * @returns                 Summary text.
 */
const SelectValueContainerSummary: FunctionComponent<IProps> = ({ description, valuesCount }) => {
    return (
        <span className="select-value-container-summary">
            {valuesCount} {description} selected
        </span>
    );
};

export default memo(SelectValueContainerSummary);
